import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Brands/services/constants";

export const getBrandTrackedDomains = createAction(`${moduleSlug}/GET_BRAND_TRACKED_DOMAINS`);
export const getBrandTrackedDomainsSuccess = createAction(`${moduleSlug}/GET_BRAND_TRACKED_DOMAINS/SUCCESS`);
export const getBrandTrackedDomainsError = createAction(`${moduleSlug}/GET_BRAND_TRACKED_DOMAINS/ERROR`);

export const getBrandTrackedDomainsByBrandCode = createAction(`${moduleSlug}/GET_BRAND_TRACKED_DOMAINS_BY_BRAND_CODE`);
export const setBrandTrackedDomainsByBrandCode = createAction(`${moduleSlug}/SET_BRAND_TRACKED_DOMAINS_BY_BRAND_CODE`);
